import type { UserRole } from '@/entities/session/types'

/**
 * Indica se o onboarding deve ser considerado concluído automaticamente.
 * System admin e admin não precisam passar pelo onboarding.
 */
export function shouldForceOnboardingCompleted(
  role: UserRole,
  isSystemAdmin: boolean,
): boolean {
  return isSystemAdmin || role === 'admin'
}
